import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const DplNav = ({ authUser, signOut }) => {
  const location = useLocation();

  return (
    <div className='dropdown'>
      <a
        href='#/'
        className='d-inline-flex align-items-center link-dark text-decoration-none dropdown-toggle px-3 py-2 rounded-pill bg-white border shadow-xs transition-all hover-scale'
        data-bs-toggle='dropdown'
        aria-expanded='false'
        style={{ border: '1px solid #e2e8f0' }}
      >
        <div
          className='p-1 bg-primary bg-opacity-10 text-primary rounded-circle me-2 d-flex align-items-center justify-content-center'
          style={{ width: '32px', height: '32px' }}
        >
          <i className='bi bi-mortarboard-fill small'></i>
        </div>
        <div className='text-start me-2'>
          <div
            className='fw-bold text-dark mb-0 leading-tight'
            style={{ fontSize: '0.875rem' }}
          >
            {authUser?.fullName}
          </div>
          <div
            className='text-muted small'
            style={{ fontSize: '0.75rem' }}
          >
            Dosen Pembimbing Lapangan
          </div>
        </div>
      </a>

      <ul
        className='dropdown-menu dropdown-menu-lg-end shadow-lg border-0 rounded-4 p-2 mt-2 mt-lg-3'
        style={{
          minWidth: '260px',
          border: '1px solid rgba(0,0,0,0.05)',
        }}
      >
        <li className='px-3 py-2 mb-2'>
          <h6 className='fw-bold text-dark mb-0'>
            {authUser?.fullName}
          </h6>
          <small className='text-muted'>{authUser?.email}</small>
          <div className='mt-2'>
            <span className='badge bg-primary bg-opacity-10 text-primary rounded-pill x-small'>
              Dosen Pembimbing Lapangan
            </span>
          </div>
        </li>

        <li>
          <hr className='dropdown-divider opacity-50' />
        </li>

        <li>
          <Link
            className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ${location.pathname === '/dpl/home' ? 'active' : ''}`}
            to='/dpl/home'
          >
            <i
              className={`bi bi-house-fill ${location.pathname === '/dpl/home' ? 'text-white' : 'text-primary opacity-75'}`}
            ></i>
            <span>Dashboard</span>
          </Link>
        </li>

        <li className='dropdown-header small text-uppercase text-muted fw-bold pt-2 pb-1'>
          Monitoring
        </li>

        <li>
          <Link
            className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ps-4 ${location.pathname === '/dpl/monitoring-veci' ? 'active' : ''}`}
            to='/dpl/monitoring-veci'
          >
            <i
              className={`bi bi-clipboard-data-fill ${location.pathname === '/dpl/monitoring-veci' ? 'text-white' : 'text-primary opacity-75'}`}
            ></i>
            <span>Monitor VECI</span>
          </Link>
        </li>

        <li>
          <Link
            className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ps-4 ${location.pathname === '/dpl/monitoring-bmc' ? 'active' : ''}`}
            to='/dpl/monitoring-bmc'
          >
            <i
              className={`bi bi-kanban-fill ${location.pathname === '/dpl/monitoring-bmc' ? 'text-white' : 'text-primary opacity-75'}`}
            ></i>
            <span>Monitor BMC</span>
          </Link>
        </li>

        <li>
          <Link
            className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ${location.pathname === '/dpl/escalations' ? 'active' : ''}`}
            to='/dpl/escalations'
          >
            <i
              className={`bi bi-megaphone-fill ${location.pathname === '/dpl/escalations' ? 'text-white' : 'text-primary opacity-75'}`}
            ></i>
            <span>Eskalasi</span>
          </Link>
        </li>

        <li>
          <hr className='dropdown-divider opacity-50' />
        </li>

        <li>
          <a
            onClick={(e) => {
              e.preventDefault();
              signOut();
            }}
            className='dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 text-danger'
            href='#/'
          >
            <i className='bi bi-box-arrow-right'></i>
            <span className='fw-bold'>Sign out</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default DplNav;
